import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Accordion,
  Badge,
  FilterAccordionHeader,
} from '@folio/stripes-components';
import { FormattedMessage } from 'react-intl';
import EntityData from './EntityData';
import css from '../../styles.css';

function EntityAccordion({ basePath, entity }) {
  const [toggle, setToggle] = useState(true);

  const renderAccordionHeader = () => {
    return (
      <div className={css.badgeStyle}>
        <Badge>{entity?.data?.length || 0}</Badge>
      </div>
    );
  };

  return (
    <div key={entity.key}>
      <Accordion
        id={`default-fields-entity-accordion-${entity.key}`}
        label={
          <h2>
            <FormattedMessage
              id={`ui-plugin-inventory-templates.templateView.templateSections.namespace.${entity.key}`}
              defaultMessage={entity.key}
            />
          </h2>
        }
        onToggle={() => setToggle(!toggle)}
        open={toggle}
        separator={entity.key !== 'instance'}
        closedByDefault
        header={FilterAccordionHeader}
        displayWhenOpen={renderAccordionHeader()}
        displayWhenClosed={renderAccordionHeader()}
      >
        <EntityData basePath={basePath} entityData={entity.data} />
      </Accordion>
    </div>
  );
}

EntityAccordion.propTypes = {
  basePath: PropTypes.string,
  entity: PropTypes.object,
};

export default EntityAccordion;
